<template>
  <header class="contenedor-nav">
    <input type="checkbox" id="btn-menu">
      <label for="btn-menu" class="icon-bars2" @click="menuHamburguesa()" v-if="store.user.nombre !== null">
        <div id="nav-icon3" v-bind:class="{ open: isActive }">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </label>
    <a :href="this.url" class="logo-navegador">
      <img src="@/assets/logo-aayi.png" alt="Logo Asociación Argentina de Yoga Iyengar">
    </a>
    <nav class="contenedor_botones_nav">
      <router-link to="/datos-personales" class="boton-cpanel" v-if="store.user.nombre !== null" @click.native="cerrarMenu()">Panel del Socio</router-link>
      <router-link to="/beneficios" class="boton-cpanel" v-if="store.user.nombre !== null" @click.native="cerrarMenu()">Beneficios</router-link>
      <!-- <router-link to="/examen-nivel-1" class="boton-cpanel" v-if="store.user.nombre !== null && mostrarBotonExamen" @click.native="cerrarMenu()">Incripción a Examen</router-link> -->
      <!-- <router-link to="/examen-nivel-1" class="boton-cpanel" v-if="store.user.nombre !== null && store.boton" @click.native="cerrarMenu()">Inscripción al Examen</router-link> -->
      <!-- <router-link to="/seminario-jawahar-socio" class="boton-cpanel" v-if="store.user.nombre !== null" @click.native="cerrarMenu()">Seminario</router-link> -->
      <!-- <router-link to="/viveka" class="boton-cpanel" v-if="store.user.nombre !== null" @click.native="cerrarMenu()">Viveka</router-link> -->
      <!-- <router-link to="/samyoga-2025-socio" class="boton-cpanel" v-if="store.user.nombre !== null" @click.native="cerrarMenu()">Samyoga 2025</router-link> -->
      <div v-if="store.user.perfil_id == 1" class="exclusivo-dropdown">
        <p @click="desplegar">Comunicados</p>
        <div class="no-mostrar" v-bind:class="{ contendor_nav_exclusivo_profes: status}">
          <div>
            <router-link to="/guia" class="boton-cpanel" @click.native="cerrarMenu(1)">Guía para la enseñanza</router-link>
            <router-link to="/nivel-1-requisitos" class="boton-cpanel" @click.native="cerrarMenu(1)">Nivel 1</router-link>
            <a
             href="https://docs.google.com/forms/d/e/1FAIpQLSeq6RTw9jXFfHy44ZX9sRsx4X3ZfTtJehp__KJREJsZuRo6lQ/viewform"
             target="_blank"
             class="boton-cpanel"
             >
              Difusión Boletín Mensual
            </a>
          </div>
        </div>
      </div>
      <router-link to="/panel-de-control" class="boton-cpanel" v-if="store.user.tipo_id == 1" @click.native="cerrarMenu()">CPanel</router-link>
      <router-link to="/mesas-de-examenes" class="boton-cpanel" v-if="store.user.boton_mesa_examen == 1" @click.native="cerrarMenu()">Mesas de Examenes</router-link>
      <!-- <router-link to="/mentorias" class="boton-cpanel" v-if="store.user.boton_mentorias == 1" @click.native="cerrarMenu()">Mentorias</router-link> -->
      <button @click="logout()" class="boton-log-out no-mostrar" v-if="store.user.nombre !== null">
        <!-- <img src="@/assets/user.png" alt="Imagen Usuario"> -->
        Logout
      </button>
    </nav>
  </header>
</template>

<script>
import store from '../store'
import authService from '../services/auth'
// import mentorService from '../services/mentor'
export default {
  name: 'Navegador',
  data: function () {
    return {
      store,
      url: '/',
      currentUrl: true,
      isActive: false,
      status: false,
      mostrarBotonExamen: false
    }
  },
  // watch: {
  //   '$route' () {
  //     console.log('222222')
  //     this.isActive = !this.isActive
  //   }
  // },
  methods: {
    logout () {
      authService
        .logout()
        .then(rta => {
          this.store.user = {
            persona_id: null,
            socio_id: null,
            email: null,
            nombre: null,
            apellido: null,
            tipo_id: null,
            perfil_id: null,
            socio_numero: null,
            imagen: null,
            dni: null,
            direccion_1: null,
            provincia_id_1: null,
            boton_mesa_examen: null
          }
          // this.store.boton = null
          // Redirecciono a la Home
          this.$router.push('/')
        })
    },
    menuHamburguesa () {
      console.log(document.querySelector('.icon-bars2'))
      console.log('wwwwww')
      this.isActive = !this.isActive
      // document.querySelector('.icon-bars2').toggleClass('open')
    },
    cerrarMenu (id) {
      console.log('qqqqq')
      this.isActive = !this.isActive
      document.getElementById('btn-menu').checked = false
      if (id === 1) {
        this.desplegar()
      } else {
        this.status = false
      }
    },
    desplegar () {
      console.log('wwwwrrrr')
      this.status = !this.status
    }
  },
  mounted: function () {
    console.log('refresh')
    console.log(JSON.parse(localStorage.getItem('userData')).persona_id)
    if (this.$route.name === 'Home' || this.$route.name === 'RecuperarPassword' || this.$route.name === 'ReseteraPassword') {
      this.currentUrl = false
      console.log('Current URL22222 => ' + this.currentUrl)
      console.log('Current URL22222 => ' + this.$route.name)
    } else {
      console.log('popopopo')
    }
    // mentorService
    //   .checkMostrarBotonExamenPorPersonaId(JSON.parse(localStorage.getItem('userData')).persona_id, 25) // Valida si puede ver el boton
    //   .then(respuesta => {
    //     if (respuesta.success) {
    //       this.store.boton = true
    //       console.log('podes ver el boton')
    //     }
    //   })
    // mentorService
    //   .checkMostrarBotonMesaDeExamenPorPersonaId(JSON.parse(localStorage.getItem('userData')).persona_id) // Valida si puede ver el boton
    //   .then(respuesta => {
    //     if (respuesta.success) {
    //       this.store.boton = true
    //       console.log('Podes ver el boton')
    //       console.log(respuesta)
    //     } else {
    //       console.log('NO podes ver el boton')
    //       console.log(respuesta)
    //     }
    //   })
  }
}
</script>
